export default __webpack_public_path__ + "static/media/mtt4.f38ab29d.jpg";